export type CreateDeploymentRequestInterfacePartnerNamesResponse = {
  /**
   * Status
   */
  status: string;

  /**
   * Error
   */
  error: string;

  /**
   * Message List
   */
  message: Message[];

  /**
   * Warning Message
   */
  warningMessage: string[];
};

type Message = {
  /**
   * Error ID
   */
  errorId: string;

  /**
   * Message ID
   */
  messageId: string;

  /**
   * Message
   */
  message: string;

  /**
   * Details
   */
  details: Detail[];
};

type Detail = {
  /**
   * Message ID
   */
  messageId: string;

  /**
   * Message
   */
  message: string;
};
